<template>
  <div style="border:1px dashed #A9A9A9;margin-top:4px;padding:8px 8px">
    <el-row>
      <el-col :span="4">
        <label>{{ evalName }}</label>
      </el-col>
      <el-col :span="20">
        <el-checkbox-group v-model="valueSelectList">
          <el-checkbox
            v-for="item in evalValueArray"
            :label="item.id"
            :key="item.id"
            :checked="item.selected"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "evalModelValueOption",
  components: {},
  props: ["index", "type", "evalValueObject"],
  data() {
    return {
      evalName: "",
      evalValueArray: [],
      valueSelectList: [],
    };
  },
  watch: {
    valueSelectList: "getSelectValue",
  },
  computed: {},
  methods: {
    getSelectValue() {
      this.$props.evalValueObject.selected = this.valueSelectList.length > 0;
      this.evalValueArray.forEach((e) => {
        if (this.valueSelectList.findIndex((item) => item === e.id) === -1) {
          e.selected = false;
        } else {
          e.selected = true;
        }
      });
      this.$emit(
        "getCildrenValue",
        this.$props.index,
        this.$props.type,
        this.$props.evalValueObject
      );
    },
  },
  created() {},
  mounted() {
    this.evalName = this.$props.evalValueObject.name;
    this.evalValueArray = this.$props.evalValueObject.children;
  },
};
</script>
<style lang="less" scoped></style>
